import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import API from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("No verification token provided");
      return;
    }
    API.get(`/auth/verify-email/${token}`)
      .then(({ data }) => {
        setStatus("success");
        setMessage(data.message || "Email verified successfully!");
      })
      .catch(err => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed");
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="verify-email-page">
      <div className="max-w-sm w-full text-center">
        {status === "loading" && (
          <div className="animate-spin h-10 w-10 border-2 border-primary border-t-transparent rounded-full mx-auto" />
        )}
        {status === "success" && (
          <>
            <CheckCircle size={48} className="text-emerald-500 mx-auto mb-4" weight="fill" />
            <h1 className="text-xl font-bold font-[Chivo] mb-2">Email Verified!</h1>
            <p className="text-sm text-muted-foreground mb-6">{message}</p>
            <Link to="/login">
              <Button data-testid="verify-login-btn">Go to Login</Button>
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={48} className="text-red-500 mx-auto mb-4" weight="fill" />
            <h1 className="text-xl font-bold font-[Chivo] mb-2">Verification Failed</h1>
            <p className="text-sm text-muted-foreground mb-6">{message}</p>
            <Link to="/login">
              <Button variant="outline" data-testid="verify-back-btn">Back to Login</Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
